import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/PortalLogin';
import TenantSelectPage from './pages/ContextSelectPage';
import PortalWorkspace from './pages/PortalWorkspace';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/select-tenant" element={<TenantSelectPage />} />
        <Route path="/workspace" element={<PortalWorkspace />} />
        <Route path="/manager" element={<Navigate to="/workspace" replace />} />
        <Route path="/purchaser" element={<Navigate to="/workspace" replace />} />
        <Route path="/admin" element={<Navigate to="/workspace" replace />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
